import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { fadeUp, staggerContainer } from '../motion/presets';

/**
 * SectionWrapper
 * Provides consistent section layout with scroll-triggered animations.
 */
export default function SectionWrapper({ id, children, className = '' }) {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px',
    });

    return (
        <section id={id} className={className}>
            <motion.div
                ref={ref}
                className="container"
                variants={staggerContainer(0.1, 0.15)}
                initial="hidden"
                animate={inView ? 'visible' : 'hidden'}
            >
                {children}
            </motion.div>
        </section>
    );
}

/**
 * SectionHeader
 * Consistent section title with label + heading
 */
export function SectionHeader({ label, title, subtitle }) {
    return (
        <motion.div className="section-header" variants={fadeUp}>
            {label && <span className="section-label">{label}</span>}
            <h2 className="section-heading">{title}</h2>
            {subtitle && <p className="section-subheading">{subtitle}</p>}
        </motion.div>
    );
}
